import TablePaginationCustom from './TablePaginationCustom';

export default TablePaginationCustom;
